// Keeps the "Booked Today" KPI list (bookedTodayDeals) in sync with the
// optimistic count increment that happens when a collection is booked from the
// detail panel. Without this, the stat card count drifts above the modal list
// because each booking bumps the count but never appends to the list, and the
// page deliberately does not auto-reload (HubSpot search index lags after a PATCH).
export function addBookedTodayDeal(bookedTodayDeals, shipment, carrier, today) {
  if (!shipment) return bookedTodayDeals
  if (bookedTodayDeals.some(d => d.id === shipment.id)) return bookedTodayDeals

  const bookedDeal = {
    ...shipment,
    carrier: carrier || shipment.carrier,
    collection_booked_date: today
  }
  return [bookedDeal, ...bookedTodayDeals]
}
